<H1> Complex Devices</H1>
<div *ngFor="let device of complexDevices;  let dp = index">
  <app-complex-devices-details [device]="device"></app-complex-devices-details>
</div>

